// extracted by mini-css-extract-plugin
export default {"accordian":"Accordian_accordian__LHf39","title":"Accordian_title__XStBu","icon":"Accordian_icon__D3yUk","contentDiv":"Accordian_contentDiv__XnbH3"};